<script>
	import { afterUpdate, onMount } from 'svelte'
	// import IntersectionObserver from './IntersectionObserver.svelte'
	import { fly, fade } from 'svelte/transition'
	import ProjectCard from './project-card.svelte'
	// import {gsap} from 'gsap'
	// gsap.registerPlugin(ScrollTrigger)
	const jq = window.$

	// export let projects = []
	// console.log(projects)
	let projects = []
	function onlyUnique(value, index, self) {
		return value && self.indexOf(value) === index
	}
	$: categories = [].concat
		.apply(
			[],
			projects.map((project) => project.categories)
		)
		.filter(onlyUnique)
		.sort()
	$: locations = [].concat
		.apply(
			[],
			projects.map((project) => project.locations)
		)
		.filter(onlyUnique)
		.sort()
	
	// console.log(categories)
	let filterLocation
	let filterCategory

	$: visible = projects.filter(function (project) {
		if (!filterCategory && !filterLocation) return true
		if (!filterCategory) return project.locations.includes(filterLocation)
		if (!filterLocation) return project.categories.includes(filterCategory)
		return (
			project.locations.includes(filterLocation) &&
			project.categories.includes(filterCategory)
		)
	})


	//async 
	function loadProjects() {
		
		// async function fetchProjects() {
			fetch('/wp-json/ctel-api/v1/projects') //posts endpoint; //! ctel
				.then((response) => response.json())
				.then((data) => {
					projects = data
				})
				.catch((error) => console.error('Error:', error))
		//}
		//await fetchProjects()
	}

	const reset = () => (filterLocation = filterCategory = null)

	// Mouse
  var mouse = {
    _x: 0,
    _y: 0,
    x: 0,
    y: 0,
    updatePosition: function(event) {
      var e = event || window.event;
      this.x = e.clientX - this._x;
      this.y = (e.clientY - this._y) * -1;
    },
    setOrigin: function(e) {
      this._x = e.offsetLeft + Math.floor(e.offsetWidth / 2);
      this._y = e.offsetTop + Math.floor(e.offsetHeight / 2);
    },
    show: function() {
      return "(" + this.x + ", " + this.y + ")";
    }
  };

	onMount(function () {
		// if (!projects) loadProjects()
		// mouse.setOrigin(container);
		loadProjects()
	})
	// afterUpdate(() => {
	// 	jq('.card-wrap').each(function (card) {
	// 		gsap.from(card, { opacity:0, y:20, duration: 0.35, stagger: 0.1, scrollTrigger: card})
	// 	})
	// })
</script>

<div class="filter-wrap">
	<div class="filtering-wrap">
		<b class="filter-label">FILTER PROJECTS:</b>
		<div style="display:inline-flex;">
			<div class="filter-cat-wrap">
				<select bind:value={filterCategory}>
					<option id="" value="" selected>Project Type</option>
					{#each categories as category}
						<option id={category.replaceAll(' ', '-')} value={category}
							>{@html category}</option
						>
					{/each}
				</select>
			</div>
			<div class="filter-loc-wrap">
				<select bind:value={filterLocation}>
					<option id="" value="" selected>Project Location</option>
					{#each locations as location}
						<option id={location.replaceAll(' ', '-')} value={location}
							>{@html location}</option
						>
					{/each}
				</select>
			</div>
		</div>
		<button type="reset" on:click={reset}>Clear Search</button>
	</div>
	{#if !projects.length}
		<p>Loading...</p>
	{:else if visible.length}
		<p in:fly={{ x: 20, duration: 350 }}>
			Viewing
			<b>{visible.length}</b>
			{#if filterCategory}
				<u>{@html filterCategory}</u>
			{/if}
			Projects
			{#if filterLocation}
				in
				<u>{@html filterLocation}</u>
			{/if}
		</p>
	{:else}
    <p in:fly="{{duration:1000,x:20}}">No Projects Found</p>
	{/if}
</div>

{#if visible.length}
<div class="projects-wrapper">
	{#each visible as project}
		<ProjectCard data={project} />
	{/each}
</div>
{/if}
